import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType, CargoQuantityUnit, PayableOver } from "__generated__/graphql";

export const WeightSchema: RegistryItem = {
	[AgreementTypeEnum.Weight]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.CargoQuantity,
				cargoQuantityUnit: CargoQuantityUnit.Mton,
				payableOver: PayableOver.Actual,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.cargoQuantityUnit": { rules: { hidden: true } },
			"calculationMethod.price": { path: "calculationMethod.price", rules: { required: true } },
			"calculationMethod.minimumPrice": { rules: { hidden: true } },
			"calculationMethod.minimumQuantityPayable": { rules: { hidden: true } },
		},
	},
};
